import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import BackPageIconButton from "../Button/BackPageIconButton";

export default function TitreDialog({ titre }) {
	return (
		<DialogTitle>
			<Stack
				direction="row"
				justifyContent="space-between"
				alignItems="center"
			>
				<Typography variant="h4">{titre}</Typography>
				<BackPageIconButton />
			</Stack>
			<Divider />
		</DialogTitle>
	);
}
